export default __webpack_public_path__ + "9810f3d043e698a0ff44a0f8768e385c.png";